/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Content\Views\ViewsCar.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Wednesday July 19th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Wednesday, 20th December 2023 05:33:15
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import { CarViews, UserViews, Views } from "Type/viewsType";
import { Link } from "react-router-dom";
import RouterPathResolver from "Config/Router/RouterPathResolver";
import translator from "MultiLanguage/TranslationWrapper";
import { TablePaper } from "Content/Table/TablePaper";
import { TableCell, TableRow } from "@mui/material";

type ViewProps = {
    views: Views[];
    className?: string;
    showCarInfo?: boolean;
    showUserInfo?: boolean;
    nbViews?: number;
}

function ViewsCar(props: ViewProps) {
    const viewKeys = ["Date"];
    if (props.showUserInfo)
        viewKeys.push("Name", "Company", "Commercial");
    if (props.showCarInfo)
        viewKeys.push("Car", "RegNb");
    viewKeys.push("Views");

    const findDate = (val: Views) => {
        return val.seenCars.map(v => v.Date).sort((a, b) => new Date(a).getTime() - new Date(b).getTime()).reverse()[0];
    };

    const buildMyRows = () => {
        let views = props.views.map((val, idx) => {
            var myView: JSX.Element[] = [];
            let date = findDate(val);
            myView.push(
                <TableCell align="center" key={`viewdate-${idx}`}>
                    {new Date(date).toLocaleString()}
                </TableCell>
            );
            if (props.showUserInfo) {
                myView.push(
                    <TableCell align="center" key={`username-${idx}`} className="text-capitalize">
                        <Link to={`${RouterPathResolver.pathUser_BY_ID.path.replace(":id", val.id)}`}>
                            {`${(val as UserViews).FirstName!} ${(val as UserViews).LastName}`}
                        </Link>
                    </TableCell>,
                    <TableCell align="center" key={`company-${idx}`} className="text-capitalize">
                        {`${(val as UserViews).Company?.Name}`}
                    </TableCell>,
                    <TableCell align="center" key={`username-commercial-${idx}`} className="text-capitalize">
                        <Link to={`${RouterPathResolver.pathUser_BY_ID.path.replace(":id", (val as UserViews).Commercial?.id)}`}>
                            {`${(val as UserViews).Commercial?.FirstName} ${(val as UserViews).Commercial?.LastName}`}
                        </Link>
                    </TableCell>
                );
            }
            if (props.showCarInfo) {
                myView.push(
                    <TableCell align="center" key={`car-${idx}`} className="text-capitalize">
                        <Link to={`${RouterPathResolver.pathCar_BY_ID.path.replace(":id", val.id)}`}>
                            {`${(val as CarViews).Brand} ${(val as CarViews).Model}`}
                        </Link>
                    </TableCell>,
                    <TableCell align="center" key={`regNb-${idx}`} className="text-uppercase">
                        <Link to={`${RouterPathResolver.pathCar_BY_ID.path.replace(":id", val.id)}`}>
                            {`${(val as CarViews).RegNb}`}
                        </Link>
                    </TableCell>,
                );
            }
            myView.push(
                <TableCell align="center" key={`seen-${idx}`}>
                    {val.seenCars.length}
                </TableCell>
            );
            return (<TableRow hover key={`view-${idx}`}>{myView}</TableRow>);
        });
        return views;
    };

    return(
        <div className={`${props.className}`}>
            {props.nbViews ?
                <h4>
                    {translator.decode("dynamic.views")} {props.nbViews}
                </h4> :
                null
            }
            <TablePaper headerList={viewKeys} items={buildMyRows()} />
        </div>
    );
};

export default ViewsCar;
